import React from 'react';
import Perf from 'react-addons-perf';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 20px;
  bottom: 20px;
  padding: 10px;
  background: #bada55;
  border: 2px solid black;
  text-align: center;
  z-index: 100000;

  > h1 {
    font-size: 1.5em;
  }

  > button {
    display: block;
    margin-top: 10px;
    padding: 5px;
  }
`;

class PerfProfiler extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { started: false };
  }

  toggle = () => {
    const { started } = this.state;

    started ? Perf.stop() : Perf.start();

    this.setState({ started: !started });
  }

  printWasted = () => {
    const lastMeasurements = Perf.getLastMeasurements();

    Perf.printWasted(lastMeasurements);
  }

  printOperations = () => {
    const lastMeasurements = Perf.getLastMeasurements();

    Perf.printOperations(lastMeasurements);
  }

  render() {
    const { started } = this.state;

    return (
      <Wrapper>
        <h1>Performance Profiler</h1>
        <button onClick={this.toggle}>{started ? 'Stop' : 'Start'}</button>
        <button onClick={this.printWasted}>Print Wasted</button>
        <button onClick={this.printOperations}>Print Operations</button>
      </Wrapper>
    );
  }
}

export default PerfProfiler;



// WEBPACK FOOTER //
// ./src/components/molecules/PerfProfiler/index.js